import { ComponentProps } from "react"
import { ProfileGalleryItemFragment } from "../../types.graphql"
import { ResponsiveImage } from "@components/atoms/ResponsiveImage"

export function ProfileGalleryImage({ item, ...rest }: { item: ProfileGalleryItemFragment } & ComponentProps<typeof ResponsiveImage>) {
  return item?.image ? (
    <ResponsiveImage srcSet={item?.image?.srcSet} aspect={item?.image?.aspect!} {...rest} />
  ) : item?.uploadImage ? (
    <ResponsiveImage srcSet={item?.uploadImage?.srcSet} aspect={item?.uploadImage?.mediaDetails?.width! / item.uploadImage.mediaDetails?.height!} {...rest} />
  ) : null
}
